import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=0ef33de4&scoped=true&"
import script from "./Popup.vue?vue&type=script&lang=js&"
export * from "./Popup.vue?vue&type=script&lang=js&"
import style0 from "./Popup.vue?vue&type=style&index=0&id=0ef33de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef33de4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconClose: require('/opt/build/repo/components/icons/IconClose.vue').default})
